import { useCallback, useEffect, useRef, useState } from "react";

export const useAccordion = (initialExpanded: boolean = false) => {
  const [isExpanded, setIsExpanded] = useState(initialExpanded);
  const contentRef = useRef<HTMLDivElement>(null);

  const toggleExpansion = useCallback(() => {
    setIsExpanded((prevExpanded) => !prevExpanded);
  }, []);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.maxHeight = isExpanded ? `${contentRef.current.scrollHeight}px` : "0px";
    }
  }, [isExpanded]);

  return { isExpanded, contentRef, toggleExpansion };
};
